/**
 * @file Final checkout price breakdown component.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Spinner from '../global/Spinner';
import Badge from '../global/Badge';
import { formatPriceForDisplay } from '../../util/format-money';

const propTypes = {
  loading: PropTypes.bool,
  shippingPrice: PropTypes.number,
  taxPrice: PropTypes.number,
  finalPrice: PropTypes.number,
  totalPrice: PropTypes.number,
  className: PropTypes.string,
  showTotalPrice: PropTypes.bool,
};

const CheckoutPrice = ({
  loading,
  shippingPrice,
  taxPrice,
  finalPrice,
  totalPrice,
  className,
  showTotalPrice = true,
}) => {
  const classes = classNames({
    'checkout-final-price': true,
    [className]: !!className,
  });

  const finalPriceDisplay = () => {
    if (loading) {
      return <Spinner size="xs" />;
    }

    if (finalPrice == null) {
      return null;
    }

    if (finalPrice === 0) {
      return (
        <Badge badgeSize="sm" badgeStyle="success-vibrant">
          Pre-Paid
        </Badge>
      );
    }

    if (totalPrice === finalPrice || !totalPrice) {
      return `$${formatPriceForDisplay(finalPrice)}`;
    }

    return (
      <Fragment>
        <del className="text-sm">${formatPriceForDisplay(totalPrice)}</del> $
        {formatPriceForDisplay(finalPrice)}
      </Fragment>
    );
  };

  return (
    <div className={classes}>
      {shippingPrice > 0 && (
        <div className="d-flex justify-content-between mb-1 text-sm text-muted">
          <span>Shipping &amp; handling:</span>
          <span>${formatPriceForDisplay(shippingPrice)}</span>
        </div>
      )}

      {taxPrice > 0 && (
        <div className="d-flex justify-content-between my-1 text-sm text-muted">
          <span>Taxes:</span>
          <span>${formatPriceForDisplay(taxPrice)}</span>
        </div>
      )}

      {showTotalPrice && (
        <div className="d-flex justify-content-between align-items-center">
          <span>Total Price:</span>
          <span className="text-bold text-dark">{finalPriceDisplay()}</span>
        </div>
      )}
    </div>
  );
};

CheckoutPrice.propTypes = propTypes;

export default CheckoutPrice;
